import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRouter } from "vue-router";

import NavbarLayout from "@/layouts/NavbarLayout.vue";
import FullContentLayout from "@/layouts/FullContentLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheLayout',
  setup(__props) {

const layout = computed(() => {
  const router = useRouter();

  switch (router.currentRoute.value.meta.layout) {
    case "FullContentLayout":
      return FullContentLayout;

    case "NavbarLayout":
    default:
      return NavbarLayout;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})